import React from 'react';
import { StyledTable, StyledTableBodyScroll, StyledTableHeaderScroll } from './Table.styled';
import { TBody } from './TBody';
import { THead } from './THead';
export function Table(props) {
  if (props.tbodyHeight) {
    var stickyTHead = null;
    var hiddenTHead = null;
    var scrollableTBody = null;
    React.Children.forEach(props.children, function (child) {
      if (/*#__PURE__*/React.isValidElement(child)) {
        if (child.type === THead) {
          stickyTHead = /*#__PURE__*/React.cloneElement(child);
          hiddenTHead = /*#__PURE__*/React.cloneElement(child, {
            hidden: true
          });
        }
        if (child.type === TBody) {
          scrollableTBody = /*#__PURE__*/React.cloneElement(child);
        }
      }
    });
    if (stickyTHead && hiddenTHead && scrollableTBody) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledTableHeaderScroll, null, /*#__PURE__*/React.createElement(StyledTable, null, stickyTHead)), /*#__PURE__*/React.createElement(StyledTableBodyScroll, {
        style: {
          maxHeight: props.tbodyHeight
        }
      }, /*#__PURE__*/React.createElement(StyledTable, null, hiddenTHead, scrollableTBody)));
    }
  }
  return /*#__PURE__*/React.createElement(StyledTable, null, props.children);
}